<template>
  <div>
    <header-logos></header-logos>
    <v-container style="min-height: calc(100% - 450px)">
      <router-view></router-view>
    </v-container>
    <footer-ciat></footer-ciat>
  </div>
</template>

<script>
import HeaderLogos from "@/components/Header";
import FooterCiat from "@/components/FooterCiat";
export default {
  name: "Home",
  components: {
    HeaderLogos,
    FooterCiat,
  },
  data() {
    return {};
  },
  methods: {
    irPublicaciones() {
      this.$router.push("/admin/publicaciones");
    },
    irIndices() {
      this.$router.push("/admin/indices");
    },
    irVariables() {
      this.$router.push("/admin/variables");
    },
    irClima() {
      this.$router.push("/admin/clima");
    },
  },
};
</script>
